import * as platformDetection from "platform";

export const platformDetector = {
	isIosDevice: () => {
		const device = platformDetection.parse(navigator.userAgent);
		const macOSfamily = ["ios", "os x"];
		return macOSfamily.includes(device.os.family.toLowerCase());
	},
	isIosMobileDevice: () => {
		const userAgent = navigator.userAgent || navigator.vendor || window.opera;
		return /iPhone|iPad|iPod/.test(userAgent);
	}
};
